export const RebateEventStatus = Object.freeze({
  INITIAL: 'Initial',
  NEW: 'New',
  SENT: 'Sent',
  REGISTRATION_ACCEPTED: 'Registration accepted',
  REJECTED: 'Rejected',
  WITHDRAWAL: 'Withdrawal Accepted',
});

export default RebateEventStatus;
